import { withInstall } from '@tav-ui/utils/with-install'
import ButtonModal from './src/button-modal.vue'
const TaButtonModal = withInstall(ButtonModal)
export { TaButtonModal }
export default TaButtonModal
export * from './src/types'
